import React, { useEffect, useState } from "react";
import { Spinner, Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { createAbout, updateAbout } from "../../services/Admin/adminServices";
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { uploadFileToS3 } from "../../../lib/S3Bucket";

const AboutForm = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { info, isEditMode } = location.state || {};
  const [uploadingImage, setUploadingImage] = useState(false);
  const [imagePreview, setImagePreview] = useState(info?.image || null);

  useEffect(() => {
    if (!location.state) {
      navigate("/admin/about");
    }
  }, [location.state, navigate]);

  const validationSchema = Yup.object({
    description: Yup.string().required("Description is required"),
  });

  // FIXED: Added 'date' to initial values
  const initialValues = isEditMode
    ? {
        aboutId: info?._id || "",
        title: info?.title || "",
       
        description: info?.description || "",
        image: info?.image || "",
         established:info?.established || ""
      }
    : {
        title: "",
  
        description: "",
        image: "",
 established:""
      };

  // Clear image preview and URL
  const handleClearImage = (setFieldValue) => {
    setImagePreview(null);
    setFieldValue("image", "");
  };

  const handleSubmit = async (values) => {
    try {
   const cleanedDescription = values.description
  .replace(/<p><br><\/p>/g, "")
  .trim();

const payload = {
  ...values,
  description: cleanedDescription,
};
      if (isEditMode) {
        await updateAbout(payload);
        toast.success("Updated successfully");
      } else {
        // FIXED: Now correctly calls createAbout when adding a new entry
        await createAbout(values);
        toast.success("Created successfully");
      }
      navigate("/about");
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  const handleFileUpload = async (e, fieldName, setFieldValue) => {
    const file = e.target.files[0];
    if (!file) return;

     const MAX_FILE_SIZE = 5 * 1024 * 1024; 
    if (file.size > MAX_FILE_SIZE) {
      toast.error("File size must be less than 5MB");
      e.target.value = null; 
      return;
    }
    try {
      setUploadingImage(true);
      const key = `uploads/${Date.now()}-${file.name}`;
      const res = await uploadFileToS3(file, key);

      if (res) {
        setImagePreview(URL.createObjectURL(file));
        setFieldValue(fieldName, res);
      }
    } catch (error) {
      toast.error("File upload failed");
      setImagePreview("");
    } finally {
      setUploadingImage(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 style={{ color: "#87C55F" }}>
          {isEditMode ? "Edit About" : "Add New About"}
        </h2>

        <Button variant="secondary" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      <div className="card p-4 shadow-sm">
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, isSubmitting }) => (
            <Form>
              {/* Title */}
              <div className="mb-3">
                <label className="form-label">Title</label>
                <Field
                  name="title"
                  className="form-control"
                  style={{ borderColor: "#87C55F" }}
                />
              </div>

              {/* Date */}
              <div className="mb-3">
                <label className="form-label">Established On</label>
                <Field
                  type="date"
                  name="established"
                  className="form-control"
                  style={{ borderColor: "#87C55F" }}
                />
              </div>

              {/* Description */}
              <div className="mb-3">
                <label className="form-label">Description</label>
                <ReactQuill
                  theme="snow"
                  value={values.description}
                  onChange={(content) => setFieldValue("description", content)}
                  style={{ height: "300px", marginBottom: "40px" }}
                />
                <ErrorMessage
                  name="description"
                  component="div"
                  className="text-danger mt-2"
                />
              </div>

              {/* Image Upload Section */}
              <div className="mt-3">
                <label className="form-label">Image</label>
                <input
                  type="file"
                  id="image"
                  className="form-control"
                  accept="image/*"
                  onChange={(e) => handleFileUpload(e, "image", setFieldValue)}
                  disabled={uploadingImage}
                  style={{ borderColor: "#87C55F" }}
                />
                <small className="text-muted d-block mt-1">
                  Max file size: 5MB. Supported formats: JPG, PNG, GIF, WebP
                </small>
              </div>

              {/* Image Preview */}
              {imagePreview && (
                <div className="mb-3 mt-3">
                  <label className="form-label">Image Preview</label>
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: "100%",
                    }}
                  >
                    <img
                      src={imagePreview}
                      alt="Preview"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "300px",
                        objectFit: "cover",
                        borderRadius: "4px",
                        border: "2px solid #87C55F",
                      }}
                    />
                    <button
                      type="button"
                      className="btn btn-sm btn-danger"
                      onClick={() => handleClearImage(setFieldValue)}
                      style={{
                        position: "absolute",
                        top: "5px",
                        left: "5px",
                      }}
                    >
                     x
                    </button>
                  </div>
                </div>
              )}
              
              {/* Loading State for Image */}
              {uploadingImage && (
                <div className="mt-2 text-success">
                  <Spinner animation="border" size="sm" className="me-2" />
                  Uploading image...
                </div>
              )}

              {/* Submit */}
              <div className="text-end mt-4">
                <Button
                  type="submit"
                  style={{ backgroundColor: "#87C55F", border: "none" }}
                  disabled={isSubmitting || uploadingImage}
                >
                  {isSubmitting ? "Saving..." : isEditMode ? "Update" : "Create"}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AboutForm;